import { IFiltroRenegociacaoAnalise } from "../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import {
    AtualizarRenegociacaoAnaliseService,
    GetRenegociacaoAnaliseService,
    ListarRenegociacaoAnaliseService,
} from "../../../Services/Cobranca/AprovacaoRenegociacoes/AprovacaoRenegociacoesServices";
import { Controller } from "../../Controller";

export function ListarRenegociacaoAnaliseController(
    page: number,
    requestBody: IFiltroRenegociacaoAnalise
) {
    return Controller(ListarRenegociacaoAnaliseService(page, requestBody));
}

export function GetRenegociacaoAnaliseController(
    ID_CASO_COBRANCA_NEGOCIACAO_ANALISE: number
) {
    return Controller(
        GetRenegociacaoAnaliseService(ID_CASO_COBRANCA_NEGOCIACAO_ANALISE)
    );
}

export function AtualizarRenegociacaoAnaliseController(
    ID_CASO_COBRANCA_NEGOCIACAO_ANALISE: number,
    DS_STATUS: string
) {
    return Controller(
        AtualizarRenegociacaoAnaliseService(
            ID_CASO_COBRANCA_NEGOCIACAO_ANALISE,
            DS_STATUS
        )
    );
}
